<!--
  No close button anywhere on this dialog, deliberately: it is opened with `disableClose`, so the
  backdrop and Esc are already inert, and offering an X that does nothing would read as a way out.
  The two ways out are the two buttons at the bottom.
-->
<div class="min-h-full w-full flex flex-col items-center p-6 bg-default-background overflow-y-auto">

  <h2 class="self-stretch text-lg font-semibold text-title text-center m-0">
    {{ 'components.accept_legal.title' | translate }}
  </h2>

  <div class="flex items-start justify-center w-full pt-4">
    <div class="flex flex-col bg-card-background border border-solid border-border-gray rounded w-full max-w-lg px-4 py-6 gap-4">

      <ng-container *ngIf="isLoading()">
        <div class="flex justify-center py-6">
          <mat-spinner diameter="40"></mat-spinner>
        </div>
      </ng-container>

      <ng-container *ngIf="!isLoading()">
        <p class="text-sm text-default-gray text-justify m-0">
          {{ 'components.accept_legal.description' | translate }}
        </p>

        <div *ngFor="let row of rows()" class="flex flex-col gap-2 border border-solid border-border-gray rounded p-3">
          <span *ngIf="row.changeSummary" class="text-xs text-light-gray">{{ row.changeSummary }}</span>
          <!-- Unchecked by default and one box per document: a pre-ticked or shared box is not
               unequivocal, specific consent. -->
          <app-legal-consent-checkbox [titleKey]="row.titleKey"
                                      [checked]="isChecked(row.document.documentType)"
                                      (checkedChange)="toggle(row.document.documentType, $event)"
                                      (documentOpened)="openDocument(row.document.documentType)"></app-legal-consent-checkbox>
        </div>

        <button mat-raised-button color="accent" class="w-full" [disabled]="!allChecked()" (click)="accept()">
          {{ 'components.accept_legal.submit' | translate }}
        </button>

        <!-- Refusing has to remain possible, so signing out is the alternative: same size as accept
             so it is not the smaller option, coloured as the consequence it is. The colour goes on
             the span because an unthemed `mat-button` sets its own label colour. -->
        <button mat-button class="full-size-text-button" (click)="logout()">
          <span class="text-error">{{ 'components.accept_legal.logout' | translate }}</span>
        </button>
      </ng-container>

    </div>
  </div>
</div>
